import type { ReactNode } from 'react';

export const symbol_local_hospital: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M435-435v111q0 18.75 13.18 31.87 13.17 13.13 32 13.13Q499-279 512-292.13q13-13.12 13-31.87v-111h111q18.75 0 31.88-13.18 13.12-13.17 13.12-32Q681-499 667.88-512q-13.13-13-31.88-13H525v-111q0-18.75-13.18-31.88-13.17-13.12-32-13.12Q461-681 448-667.88q-13 13.13-13 31.88v111H324q-18.75 0-31.87 13.18-13.13 13.17-13.13 32Q279-461 292.13-448q13.12 13 31.87 13h111ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
